// useRouteNavigationLoading 返回路由异步页面加载期间的全局锁状态。
export function useRouteNavigationLoading() {
  return useState<boolean>('blog-route-navigation-loading', () => false)
}
